import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const changeUserStatusUseCase = async (
  userId: string,
  status: string | null,
): Promise<{ success: boolean; error?: string }> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    status === "ACTIVE"
      ? await apiUseCases.putReactivateUser(namespace, userId)
      : await apiUseCases.putDeactivateUser(namespace, userId);

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        status === "ACTIVE"
          ? "Failed to reactivate user. Please try again later."
          : "Failed to deactivate user. Please try again later.",
      ).message,
    };
  }
};
